import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';

const GB_SIZE = 10 ** 9;

export const WARNING_THRESHOLD = 0.9;

// In Bytes
export enum CONFLUENCE_STORAGE_LIMITS {
	FREE = 2_000_000_000,
	STANDARD = 250_000_000_000,
}
// The Confluence Editions that have storage limits
export type STORAGE_LIMIT_EDITIONS = ConfluenceEdition.FREE | ConfluenceEdition.STANDARD;

// The Storage Limits for each edition.
export const EDITIONS_STORAGE_LIMITS: Record<STORAGE_LIMIT_EDITIONS, CONFLUENCE_STORAGE_LIMITS> = {
	[ConfluenceEdition.FREE]: CONFLUENCE_STORAGE_LIMITS.FREE,
	[ConfluenceEdition.STANDARD]: CONFLUENCE_STORAGE_LIMITS.STANDARD,
};

/**
 * Converts currentUsage amount over the limit in bytes to GB string.
 * @param currentUsage
 * @param edition
 * @returns
 */
export const getOverLimitFormatted = (
	currentUsage: number,
	edition: STORAGE_LIMIT_EDITIONS,
): string => {
	const editionLimit = EDITIONS_STORAGE_LIMITS[edition];
	const difference = (currentUsage - editionLimit) / GB_SIZE;
	return (difference < 0 ? 0 : difference).toFixed(1);
};

export const getOverLimitPercent = (
	currentUsage: number,
	edition: STORAGE_LIMIT_EDITIONS,
): string => {
	const editionLimit = EDITIONS_STORAGE_LIMITS[edition];
	const percent = ((currentUsage - editionLimit) / editionLimit) * 100;
	return percent.toFixed(1);
};

export const getStoragePercentForEdition = (
	currentUsage: number,
	edition: STORAGE_LIMIT_EDITIONS,
): number => {
	const editionLimit = EDITIONS_STORAGE_LIMITS[edition];
	const storagePercent = Math.floor((currentUsage / editionLimit) * 100);
	return storagePercent > 100 ? 100 : storagePercent;
};

export const getIsOverEditionLimit = (currentUsage: number, edition: STORAGE_LIMIT_EDITIONS) =>
	currentUsage > EDITIONS_STORAGE_LIMITS[edition];
